<template>
 
  <!--新闻动态-->
  <div class="content_list_layout">
    <div class="list_box_layout" v-for="(item,index) in showList" :key="index">
      <div class="year_title" :class="{hidden: !compareYear(index)}">{{item.year}}</div>
      <div :class="compareBorder(index)?'list_box': 'list_box noborder'">
        <i class="iconfont icon-website-PDF"></i>
        <div class="list_content">
          <div class="list_title" @click="handleItemClick(item)">{{isEn ? (item.enTitle || item.title) : item.title}}</div>
          <div class="list_date">{{item.createDate}}</div>
        </div>
      </div>
    </div>
    <div class="web_fenye" v-if="showList && showList.length > 0">
      <paginate
        :pageCount="pageCount"
        :containerClass="'pagination'"
        :page-range="3"
        :clickHandler="pageClick"
        :first-last-button="false"
        first-button-text="<<"
        last-button-text=">>"
        :prevText="'<'"
        :nextText="'>'"
      >
      </paginate>
    </div>
   
  </div>
       
</template>

<script>
import defaultImage from '../../../assets/img/default_img.png'
export default {
  name: 'YearsTitleListView',
  components:{},
  props: {
    yearSelected:{},
    titleName:{
      type:String,
      default:''
    },
    messageList:{
      type:Array,
      default:[]
    },
    perPage:{
      type:Number,
      default:1
    },
    detailRouter:{
      type:String,
      default:''
    },
  },

  data () {
    return {
      
      showList:[],
      totalNum:0,
      pageCount:1,
      
    }
  },
  computed:{
    isEn() {
      return this.$i18n.locale === 'en';
    }
  },
  watch:{
    messageList(val){
        this.currentMessageList = val;
        this.loadData();
    },
    yearSelected(val){
      if(val == '全部年份'){
        this.currentMessageList = JSON.parse(JSON.stringify(this.messageList));
      }else{
        this.currentMessageList = this.messageList.filter((item) => {
          return item.year == val;
        });
      }
      this.loadData();
    }
  },
  methods:{
    compareYear(index){
      if(index == 0){
        return true;
      }else{
        if(this.showList[index-1].year !== this.showList[index].year){
          return true;
        }else{
          return false;
        }
      }
    },
    compareBorder(index){
      if(index == this.perPage-1){
        return true;
      }else{
        if(!this.showList[index+1] || this.showList[index+1].year !== this.showList[index].year){
          return true;
        }else{
          return false;
        }
      }
    },
    toDetailPage(messageId){
      
      let url = this.$router.resolve({
         name: this.detailRouter,
         query: {detailId:messageId}
       });
       this.$PageUtil.openNewPage(this,url.href)
       
    },
    toOpenFile(url){
      window.open(url,'_blank')
    },
    handleItemClick(item){
      if(this.detailRouter && item.messageId){
        // 有detailRouter时打开详情页
        this.toDetailPage(item.messageId);
      }else{
        // 否则打开文件链接
        this.toOpenFile(item.msgUrl||item.linkUrl);
      }
    },
    pageClick(num){
      this.showList = this.$PageUtil.getStaticPage(num,this.perPage,this.currentMessageList)
    },
    loadData(){
      
      this.totalNum = this.currentMessageList.length;
      this.pageCount = this.$PageUtil.getPageCount(this.totalNum,this.perPage);
      //获得第一页数据
      this.showList = this.$PageUtil.getStaticPage(1,this.perPage,this.currentMessageList);
    },
  },
  mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 

    
</style>
